// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"385":"96132445","451":"24b97bc2"}[chunkId] + ".css";
};